import { render, staticRenderFns } from "./AboutEight.vue?vue&type=template&id=3674b29b&"
import script from "./AboutEight.vue?vue&type=script&lang=js&"
export * from "./AboutEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports